import React, { useEffect, useState } from 'react'
import { cerealesColor } from '../../../../config/cereales'
import DetalleEstadoPlayaCalado from '../../components/reporteCamionesCalados/DetalleEstadoPlayaCalado'
import EstadoPlayaCamionesCalados from '../../components/reporteCamionesCalados/EstadoPlayaCamionesCalados'

function ReporteProductosCalado (props) {
  const { callesDeCalado, calificacionCalles, camionesCalados, ocupacionCalles, soloDetalle = false } = props
  const [data, setData] = useState([])
  const [totalProductos, setTotalProductos] = useState(null)
  const [cantidadPendientes, setCantidadPendientes] = useState(0)
  const [productosPorCereal, setProductosPorCereal] = useState([])
  const [autodescargables, setAutodescargables] = useState([])
  const [calificacionProductos, setCalificacionProductos] = useState([])
  const [productosPendientes, setProductosPendientes] = useState([])

  useEffect(() => {
    if (callesDeCalado.length > 0) {
      // zzz_total : asi esta guardado en la bd
      const total = callesDeCalado.filter((calle) => calle.claveCereal === 'zzz_total')
      if (total.length > 0) { setTotalProductos(total[0].cantidadDeCamiones) }

      const camAutodescargables = camionesCalados.filter((c) => c.autodescargable && c.estadoAutorizacion === 'Autorizado')
      const productos = []
      const calificaciones = []
      const pendientes = []

      setCantidadPendientes(0)
      let cantidad = 0

      const productosCalados = camionesCalados.reduce((prod, camion) => {
        const { claveCereal, estadoAutorizacion, calificacionCereal, caravana } = camion

        const autorizado = estadoAutorizacion === 'Autorizado'

        const productoExistente = productos.find(producto => producto.cereal === claveCereal)
        const existePendiente = pendientes.find(p => p.cereal === claveCereal)
        const existeCalificacion = calificaciones.find(c => c.cereal === claveCereal && c.calificacion === calificacionCereal && c.estadoAutorizacion === estadoAutorizacion && caravana === c.caravana)

        if (calificacionCereal !== 'Conforme') {
          if (!existeCalificacion) {
            calificaciones.push({ cereal: claveCereal, calificacion: calificacionCereal, cantidad: 1, estadoAutorizacion: estadoAutorizacion, caravana: caravana })
          } else {
            existeCalificacion.cantidad += 1
          }
        }

        if (autorizado) {
          if (!productoExistente) {
            productos.push({ cereal: claveCereal, cantidad: 1 })
          } else {
            productoExistente.cantidad += 1
          }
        } else {
          if (!existePendiente) {
            pendientes.push({ cereal: claveCereal, cantidad: 1 })
          } else {
            existePendiente.cantidad += 1
          }
          cantidad += 1
        }
        return productos
      }, [])

      setCantidadPendientes(cantidad)
      setProductosPorCereal(productosCalados)
      setCalificacionProductos(calificaciones)
      setProductosPendientes(pendientes)
      setAutodescargables(camAutodescargables)
      productosCalados.sort((a, b) => {
        return a.cereal.localeCompare(b.cereal)
      })

      const dataCalles = []
      const generarData = (ocupacionCalles) => {
        ocupacionCalles.filas.length > 0 && ocupacionCalles.filas.map((calle) => {
          return dataCalles.push([
            `C${calle.calleDeCalado}`,
            calle.ocupado,
            (calle.cerealAsignado != null) ? cerealesColor[`${calle.cerealAsignado.trim()}`] : '#e0e0e0',
            `${calle.capacidad}`,
            `${calle.cerealAsignado}`,
            `Calle ${calle.calleDeCalado}-Capacidad ${calle.capacidad}-Usado ${calle.ocupado}-Cereal ${calle.cerealAsignado}`,
            calle.ordenDeSalida
          ])
        })
        setData(dataCalles)
        return dataCalles
      }

      if (ocupacionCalles !== null && ocupacionCalles.filas_procesadas > 0 && data.length === 0) {
        if (ocupacionCalles.estado === 'exito') {
          generarData(ocupacionCalles)
        }
      }
    }
  }, [callesDeCalado, ocupacionCalles, data, camionesCalados])

  return (
    <>
      <DetalleEstadoPlayaCalado
        productosPorCereal={productosPorCereal}
        totalProductos={totalProductos}
        cantidadPendientes={cantidadPendientes}
        productosPendientes={productosPendientes}
        calificacionProductos={calificacionProductos}
        autodescargables={autodescargables}
        soloDetalle={soloDetalle}
      />

      {!soloDetalle &&
        <EstadoPlayaCamionesCalados
          data={data}
          calificacionCalles={calificacionCalles}
          camionesCalados={camionesCalados}
          dialogOpen={props.dialogOpen}
        />
      }
    </>
  )
}

export default ReporteProductosCalado
